import aguid from 'lib/aguid';

import { buildDateInputFromTerm } from './hooks/useChartDrillDowns/buildOnDateDrillDown';
import isDefined from './isDefined';

const buildDrillDown = (
  field: string,
  fieldType: FleetOps.FieldType,
  term: string,
  chartDef: VisualisationDefinition,
  dateScope: DateRangeInput,
  autoInterval?: AutoInterval,
): FixedFilter | undefined => {
  if (fieldType === 'text') {
    const newTextDrillDown: TextFilter = {
      id: aguid(),
      field,
      mode: 'plate',
      fieldType,
      keywordValues: [term],
    };
    return newTextDrillDown;
  }

  if (fieldType === 'dateText' || fieldType === 'date') {
    const newDateDrillDown: DateFilter = {
      id: aguid(),
      field,
      mode: 'plate',
      fieldType,
      dateRangeValues: [
        buildDateInputFromTerm(chartDef, term, field, dateScope, autoInterval),
      ].filter(isDefined),
    };
    return newDateDrillDown;
  }

  if (fieldType === 'float' || fieldType === 'long') {
    const newNumberDrillDown: NumberFilter = {
      id: aguid(),
      field,
      mode: 'plate',
      fieldType,
    };
    return newNumberDrillDown;
  }

  if (fieldType === 'boolean') {
    const newBooleanDrillDown: BooleanFilter = {
      id: aguid(),
      field,
      mode: 'plate',
      fieldType,
      booleanValue: term === 'true',
    };
    return newBooleanDrillDown;
  }
};

export default buildDrillDown;
